module.exports = __webpack_public_path__ + "static/media/jogos@2x.56a0587d.jpg";